import { StopIteration } from "@axioscode/api-client/lib/utils/APIResponse";
import createAsyncAction from "utils/createAsyncAction";
import dotProp from "dot-prop-immutable";

import Log from "utils/log";

export const GET_DASHBOARD_LIST_REQUESTED = "GET_DASHBOARD_LIST_REQUESTED";
export const GET_DASHBOARD_LIST_SUCCEEDED = "GET_DASHBOARD_LIST_SUCCEEDED";
export const GET_DASHBOARD_LIST_FAILED = "GET_DASHBOARD_LIST_FAILED";

export const getDashboardListAsync = createAsyncAction(
  "dashboard",
  "list",
  "GET_DASHBOARD_LIST",
  (args, getState) => [getState().dashboard.filters]
);

export const getDashboardListSearchAsync = createAsyncAction(
  "dashboard",
  "list",
  "GET_DASHBOARD_LIST",
  args => ({ search: args })
);

export const GET_DASHBOARD_LIST_NEXT_PAGE_REQUESTED =
  "GET_DASHBOARD_LIST_NEXT_PAGE_REQUESTED";
export const GET_DASHBOARD_LIST_NEXT_PAGE_SUCCEEDED =
  "GET_DASHBOARD_LIST_NEXT_PAGE_SUCCEEDED";
export const GET_DASHBOARD_LIST_NEXT_PAGE_FAILED =
  "GET_DASHBOARD_LIST_NEXT_PAGE_FAILED";

export const getDashboardListNextPageRequested = () => {
  return {
    type: GET_DASHBOARD_LIST_NEXT_PAGE_REQUESTED,
  };
};

export const getDashboardListNextPageSucceeded = content => {
  return {
    type: GET_DASHBOARD_LIST_NEXT_PAGE_SUCCEEDED,
    payload: content,
  };
};

export const getDashboardListNextPageFailed = error => {
  Log.error(error);
  return {
    type: GET_DASHBOARD_LIST_NEXT_PAGE_FAILED,
    payload: error,
    error: true,
  };
};

export const getDashboardListNextPageAsync = () => {
  return (dispatch, getState) => {
    const {
      dashboard: { list },
    } = getState();

    // Only dispatch a next page call if there is a response stored in state which is paginated
    if (dotProp.get(list, "meta.response.count")) {
      const {
        meta: { response },
      } = list;

      return response
        .next()
        .then(list => dispatch(getDashboardListNextPageSucceeded(list)))
        .catch(error => {
          // Don't resolve in this catch - throw up to StoryList's _handleInfiniteLoad
          // because this isn't really an error, but we want to use a catch() to handle it still
          if (error instanceof StopIteration) {
            throw error;
          }
          Log.error(error);
          dispatch(getDashboardListNextPageFailed(error));
        });
    } else {
      return Promise.resolve();
    }
  };
};
